module.exports = __webpack_public_path__ + "assets/images/profiles/1970-4.jpg?v=9123c802";